<template>
  <div class="about-container">
    <div class="about-box">
      <div class="left animate__animated" :class="addAnimate">
        <div class="title-box " ><span class="title">关于我们</span><span
            class="desc">/AboutUs</span></div>
          <div class="logo-box">
            <span>华艺元界</span>
            <div class="line"></div>
          </div>
        <div class="desc-box">
          华艺元界是&nbsp;金辰宇(天津)科技有限公司&nbsp;旗下，一款结合区块链与元宇宙技术的应用，为用户提供数字资产保护、版权认证及在线展览沉浸式体验。无论是艺术创作、数字收藏还是虚拟探索，这里都是你进入未来数字世界的理想入口。
        </div>
        <div class="data-box">
          <div class="data-item">
            <p class="num">10+</p>
            <p class="desc">计算机软件著作权</p>
          </div>
          <div class="data-item">
            <p class="num">3+</p>

            <p class="desc">专项发明专利</p>
          </div>
          <div class="data-item">
            <p class="num">5+</p>
            <p class="desc">行业协会会员单位</p>
          </div>
          <div class="data-item">
            <p class="num">5+</p>
            <p class="desc">行业标准制定</p>
          </div>
        </div>
      </div>
      <div class="right">
        <img src="../assets/imgs/footer-bg2.jpg" alt="">
      </div>
    </div>
    <div class="footer">
      <div class="logo-box">
        <div class="logo">
          <img src="../assets/imgs/logo.png" style="width: 20px; height: 20px;" alt="">
          <span>华艺元界</span>
        </div>
        <div class="license">艺术品经营备案：120104180008</div>
        <div class="license">网安备: 津ICP备2024014758号-4</div>
      </div>
      <ul class="about-hy">
        <span>华艺元界</span>
        <li><a target="_blank" href="https://ocnn21o9mmsk.feishu.cn/wiki/KLK2wTld9iBEcokIIFccCFEangJ?from=from_copylink">用户协议</a> </li>
        <li><a target="_blank" href="https://ocnn21o9mmsk.feishu.cn/wiki/R8kKw1QgUiWwRxkSXZ2cKollnDd?from=from_copylink">隐私协议</a></li>
      </ul>
      <ul class="about-hy">
        <span>友情链接</span>
        <li><a href="#">金辰宇(天津)科技有限公司</a> </li>
        <li><a href="https://cloud.baidu.com/">百度智能云</a> </li>
      </ul>
      <ul class="about-flow">
        <span>关注我们</span>
        <li class="tooltip-container">
          微信公众号
          <div class="tooltip-box">
            <img src="../assets/about/gzh.jpg" alt="微信公众号二维码" class="qr-code-img">
          </div>
        </li>
        <li class="tooltip-container">
          抖音
          <div class="tooltip-box">
            <img src="../assets/about/dy.jpg" alt="抖音二维码" class="qr-code-img">
          </div>
        </li>
        <li class="tooltip-container">
          新浪微博
          <div class="tooltip-box">
            <img src="../assets/about/wb.jpg" alt="新浪微博二维码" class="qr-code-img">
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['addAnimate']
}
</script>

<style lang="less" scoped>
@import url('~@/assets/css/reset.css');

.about-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  .about-box {
    width: 100%;
    height: calc(100% - 120px);
    display: flex;
    align-items: center;
    margin: 0 32px;
    box-sizing: border-box;

    .left {
      width: 50%;
      height: auto;
      text-align: start;

      .title-box {
        display: flex;
        width: 100%;
        height: 50px;

        padding-bottom: 20px;

        .title {
          color: #FF793A;
          font-size: 32px;
          font-weight: 700;
        }

        .desc {
          margin-top: 10px;
          font-size: 20px;
          text-indent: .8rem;
          font-weight: 400;
          color: #ACADAE;
        }
      }
      .logo-box{
        width: 100%;
        height: auto;
        span{
          font-size: 32px;
          color: #000;
          font-weight: 700;

        }
        .line{
          width: 80px;
          height: 2px;
          background-color: #FF793A;
          margin-top: 20px;
          margin-bottom: 20px;
          box-sizing: border-box;
        }
      }

      .desc-box {
        width: 100%;
        height: 200px;
        font-size: 20px;
        padding-right: 180px;
        line-height: 22px;
        letter-spacing: 2px;
        font-weight: 400;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        /* 限制显示行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        box-sizing: border-box;
      }
      .data-box{
        display: flex;
        width: 100%;
      padding-right: 180px;
        height: auto;
        padding-top: 20px;
        box-sizing: border-box;
        .data-item{
          width: 50%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-right: 2px solid #FF793A;
          .num{
            font-size: 32px;
            line-height: 60px;
            color: #FF793A;
          }
          .desc{
            font-size: 16px;
            color: #FF793A;
          }
          &:last-child{
            border-right: none;
          }

        }

      }

    }
    .right{
      padding-top: 80px;
      width: 40%;
      height: auto;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

    }

  }

  .footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 120px;
    padding: 0 80px;
    background-color: #FAFAFA;
    color: #8c9198;

    box-sizing: border-box;

    .logo-box {
      width: max-content;
      height: 100%;

      .logo {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;

        span {
          line-height: 20px;
          text-indent: 1rem;
          color: #000;
        }
      }

      .license {
        width: 100%;
        height: 25px;
        font-size: 14px;
        color: #8c9198;
        text-align: start;
      }
    }

    .about-hy {
      width: auto;
      height: 100%;

      span {
        display: block;
        width: 100%;
        line-height: 50px;
        color: #000;
      }

      li {
        display: block;
        width: auto;
        height: 20px;
        font-size: 12px;

        a:hover {
          color: #000;
        }
      }
    }

    .about-flow {
      width: auto;
      height: 100%;

      span {
        display: block;
        width: 100%;
        line-height: 50px;
        color: #000;
      }

      li {
        display: block;
        width: auto;
        height: 20px;
        font-size: 12px;
        position: relative;
      }

      .tooltip-container {
        cursor: pointer;

        &:hover .tooltip-box {
          display: block;
        }
      }

      .tooltip-box {
        width: 80px;
        height: 80px;
        position: absolute;
        top: -120px;
        left: 50%;
        transform: translateX(-50%);
        background: white;
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 15px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 1000;
        display: none;
        text-align: center;

        &::after {
          content: '';
          position: absolute;
          bottom: -12px;
          left: 50%;
          transform: translateX(-50%);
          border-width: 10px;
          border-style: solid;
          border-color: white transparent transparent transparent;
        }
      }

      .qr-code-img {
        width: 100%;
        height: 100%;
        display: block;
        margin: 0 auto;
      }
    }
  }
}
</style>